import script from "./SubtotalMobileWidget.vue?vue&type=script&lang=ts&setup=true"
export * from "./SubtotalMobileWidget.vue?vue&type=script&lang=ts&setup=true"

import "./SubtotalMobileWidget.vue?vue&type=style&index=0&id=dcf41ff8&lang=less&scoped=true"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcf41ff8"]])

export default __exports__